import SimpleLayout from "@/components/SimpleLayout"


export default function HomePage() {
  return (
    <SimpleLayout
      title="Hallo."
      intro="ich bin Martin Ludwig."
    >
      <div className="mb-4">
        <h2 className="underline">Meine Projekte</h2>
        <ul>
          <li><a href="https://hellocheri.com">hellocheri.com</a></li>
          <li><a href="https://dirtreemd.com">dirtreemd.com</a></li>
          <li><a href="https://idleefficiency.com">idleefficiency.com</a></li>
        </ul>
      </div>
      <div className="space-y-20">
        <ul>
          <li>
          GitHub: <a href="https://github.com/Martin-Ludwig">https://github.com/Martin-Ludwig</a>
          </li>
          <li>
          LinkedIn: <a href="https://www.linkedin.com/in/martin-ludwig-80810a200/">https://www.linkedin.com/in/martin-ludwig-80810a200/</a>
          </li>
          <li>
          Medium: <a href="https://medium.com/@bluethroat">https://medium.com/@bluethroat</a>
          </li>
        </ul>
      </div>
    </SimpleLayout>
  )
}
